package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable

sealed interface CreditUiState {
    val inputs: CreditInputs

    data class Loading(override val inputs: CreditInputs) : CreditUiState
    data class Success(override val inputs: CreditInputs, val result: CreditResult) : CreditUiState
    @Stable
    data class Error(override val inputs: CreditInputs, val error: ErrorType) : CreditUiState
}
